<template>
  <div id="app">
    <Navigation />
    <router-view :key="$route.path" />
    <Footer />
    <Banner />
    <TheWheel />
    <Wheel />
  </div>
</template>
<script>
// @ is an alias to /src
import Navigation from "@/components/TheNavigation.vue";
import Footer from "@/components/TheFooter.vue";
import Banner from "@/components/TheBanner.vue";
import Wheel from "@/components/TheLottery.vue"
import TheWheel from '@/components/TheWheel.vue'

export default {
  name: "app",
  components: {
    Navigation,
    Footer,
    Banner,
    Wheel,
    TheWheel,
  },
  methods: {
    setSource(source) {
      let src ='';
            if (source) {
                switch (source) {
                    case 'google':
                      src = 49
                        break;
                    case 'facebook':
                        src = 50
                        break;
                    case 'contents':
                        src = 95
                        break;
                    default:
                        break;
                }
                localStorage.setItem('utm_source', src);
            }
        },
        setChannel(channel) {
            if (channel) {
                switch (channel) {
                    case 'google-content-ads':
                        this.channel = 212;
                        break;
                    default:
                        break;
                }
            
                localStorage.setItem('utm_medium', this.channel);
            }
        },
        setCampaign(camp) {
            if (camp) {
                localStorage.setItem('utm_campaign', camp);
            }
        },
  },
  mounted() {
    this.$router.afterEach((to) => {
      this.setSource(to.query.utm_source);
      this.setChannel(to.query.utm_medium);
      this.setCampaign(to.query.utm_campaign);
    })
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,400;0,700;1,400;1,900&display=swap");
@import url("./assets/css/custom.css");
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.1/font/bootstrap-icons.css");

#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: "oh_golds_demoregular";
  src: url("/fonts/oh_golds_demo-webfont.woff2") format("woff2"),
    url("/fonts/oh_golds_demo-webfont.woff") format("woff");
}

.oh-golds {
  font-family: "oh_golds_demoregular";
}

@font-face {
  font-family: "trackers";
  src: url("/fonts/Trackers\ demo.otf") format("opentype");
}

.trackers {
  font-family: "trackers";
}

@import "~bootstrap/dist/css/bootstrap.css";
</style>